import React from "react";
import {Observer, TextPlus} from "web-vcore";
import {DEL, GetEntries, ToNumber} from "js-vextensions";
import {GetAsync, observer_mgl, RunInAction} from "mobx-graphlink";
import {Button, CheckBox, Column, Pre, Row, RowLR, Select, Text, Spinner, TextInput} from "react-vcomponents";
import {ShowMessageBox} from "react-vmessagebox";
import {store} from "../../Store/index.js";
import {GenericEntryInfoUI} from "../@Shared/CommonPropUIs/GenericEntryInfoUI.js";
import {DetailsUI_Base_Props, useDetailsUICore} from "../@Shared/DetailsUI_Base.js";
import {AddMap} from "../../Server/Commands/MapCommands.js";
import {DMap} from "../../Server/DB/maps/@Map.js";

export const MapDetailsUI = observer_mgl((props: DetailsUI_Base_Props<DMap>)=>{
	const {style} = props;
	const {rootRef, newData, helpers} = useDetailsUICore(props);
	const {Change, creating, enabled} = helpers;
	//const nodeAccessPolicy = GetAccessPolicy(newData.nodeAccessPolicy);

	const splitAt = 160;
	const width = 600;
	return (
		<Column ref={rootRef} style={style}>
			{!creating &&
				<GenericEntryInfoUI id={newData.id} creatorID={newData.creator} createdAt={newData.createdAt}/>}
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Pre>Name:</Pre>
				<TextInput required enabled={enabled} style={{width: "100%"}}
					value={newData.name} onChange={val=>Change(newData.name = val)}/>
			</RowLR>
			{/*<RowLR mt={5} splitAt={splitAt}>
				<TextPlus info="Note that this only applies for new nodes created in this map. (ie. if you change this setting, you must manually update the access-policies of existing nodes)">Node access policy:</TextPlus>
				<PolicyPicker value={newData.nodeAccessPolicy} onChange={val=>Change(newData.nodeAccessPolicy = val!)}>
					<Button enabled={enabled} text={nodeAccessPolicy ? `${nodeAccessPolicy.name} (id: ${nodeAccessPolicy.id})` : "(click to select policy)"} style={{width: "100%"}}/>
				</PolicyPicker>
			</RowLR>*/}
		</Column>
	);
});

export async function ShowAddMapDialog(openMapAfterCreation = true) {
	const prep = await GetAsync(()=>{
		return {}; //{accessPolicy: GetFinalAccessPolicyForNewEntry(null, null, "maps")};
	});

	let newMap = new DMap({
		//accessPolicy: prep.accessPolicy.id,
		name: "",
	});

	let error: string|n;
	const Change = (..._)=>boxController.UpdateUI();
	const boxController = ShowMessageBox({
		title: "Add map", cancelButton: true,
		message: ()=>{
			boxController.UpdateOptions({okButtonProps: {enabled: error == null}});
			return (
				<Column style={{padding: "10px 0", width: 600}}>
					<MapDetailsUI baseData={newMap} phase="create" onChange={(val, _, {getValidationError})=>Change(newMap = val, error = getValidationError())}/>
					{error && error != "Please fill out this field." && <Row mt={5} style={{color: "rgba(200,70,70,1)"}}>{error}</Row>}
				</Column>
			);
		},
		onOK: async()=>{
			const result = await new AddMap({entry: newMap}).RunOnServer();
			RunInAction("ShowAddMapDialog.onOK", ()=>{
				store.main.maps.selectedMapID = result.id;
			});
		},
	});
}